import React from 'react';
import NewsCategory from '../components/NewsCategory';

function ChitrakootNews() {
  const dummyNews = [
    {
      id: 1,
      title: "चित्रकूट में हुआ बड़ा धार्मिक आयोजन, हजारों श्रद्धालु शामिल हुए",
      description: "राम मंदिर में विशेष पूजा आयोजित की गई और हजारों श्रद्धालु दर्शन के लिए पहुंचे",
      image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440",
      timeAgo: "30m पहले"
    },
    {
      id: 2,
      title: "जिले में नई स्वास्थ्य सुविधाओं का उद्घाटन",
      description: "स्वास्थ्य विभाग ने चित्रकूट के विभिन्न ब्लॉक्स में नई चिकित्सा सेवाओं की शुरुआत की",
      image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg",
      timeAgo: "2h पहले"
    },
    {
      id: 3,
      title: "चित्रकूट को पर्यटन केंद्र बनाने की तैयारी",
      description: "जिला प्रशासन चित्रकूट को एक मुख्य पर्यटन केंद्र के रूप में विकसित करने की योजना बना रहा है",
      image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg",
      timeAgo: "4h पहले"
    }
  ];

  return <NewsCategory title="चित्रकूट" emoji="🏞️" categoryName="चित्रकूट" dummyNews={dummyNews} />;
}

export default ChitrakootNews;
